import React, { useState } from "react";
import { BiEdit, BiTrash } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { WrittenFormat } from "../WrittenFormat";
import DeleteConfirmationModal from "../DeleteConfirmationModal/DeleteConfirmationModal";

export const RenderNotes = ({ 
  notes = [], 
  setModalTab, 
  setShowModal, 
  onEditNote, 
  onDeleteNote 
}) => {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, noteId: null, noteTitle: '' });
  const [expandedContents, setExpandedContents] = useState({});

  // Helper function to truncate text by word count
  const truncateText = (text, wordLimit = 40) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ");
  };

  // Helper function to get word count
  const getWordCount = (text) => {
    if (!text) return 0;
    return text.split(/\s+/).filter(word => word.length > 0).length;
  };

  // Toggle content expansion
  const toggleContent = (noteId, e) => {
    e.stopPropagation();
    setExpandedContents(prev => ({
      ...prev,
      [noteId]: !prev[noteId]
    }));
  };

  const handleDeleteClick = (noteId, noteTitle) => {
    setDeleteModal({ isOpen: true, noteId, noteTitle });
  };

  const handleConfirmDelete = async () => {
    await onDeleteNote(deleteModal.noteId);
    setDeleteModal({ isOpen: false, noteId: null, noteTitle: '' });
  };

  const handleCancelDelete = () => {
    setDeleteModal({ isOpen: false, noteId: null, noteTitle: '' });
  };

  const handleNoteClick = (noteId) => {
    navigate(`/home/notes/details/${noteId}`);
  };

  return (
    <div className="tab-content">
      <div className="summary">
        <div>
          <p className="margin-zero exp-count">
            <strong>Total Notes Count:</strong> {notes.length}
          </p>
        </div>
        <div className="tab-add">
          <button
            onClick={() => {
              setModalTab("Notes");
              setShowModal(true);
              onEditNote(null);
            }}
          >
            Add Note
          </button>
        </div>
      </div>
      
      {notes.length === 0 ? (
        <div className="no-data-container">
          <h3 className="no-data-title">No Notes Found</h3>
          <p className="no-data-message">
            No notes have been created for this case yet. Click "Add Note" to create your first note.
          </p>
        </div>
      ) : (
        notes.map((note, index) => (
          <div 
            key={index} 
            className="order-card"
            style={{ cursor: "pointer" }}
            onClick={() => handleNoteClick(note._id)}
          >
            {console.log(note, "jksdfvh")}
            
            <div className="note-div-detail">
              <div>
                <p><strong>Title:</strong> {WrittenFormat(note.title)}</p>
                <p style={{ 
                  paddingRight: "20px",
                  wordBreak: "break-word",
                  maxWidth: "100%"
                }}>
                  <strong>Content:</strong>{" "}
                  {expandedContents[note._id]
                    ? note.content
                    : getWordCount(note.content) > 40
                    ? (
                      <>
                        {truncateText(note.content, 40)}...{" "}
                        <button
                          onClick={(e) => toggleContent(note._id, e)}
                          style={{
                            padding: "2px 8px",
                            fontSize: "12px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            backgroundColor: "#f5f5f5",
                            cursor: "pointer",
                            color: "#333",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Show More
                        </button>
                      </>
                    )
                    : note.content}
                  {expandedContents[note._id] && getWordCount(note.content) > 40 && (
                    <>
                      {" "}
                      <button
                        onClick={(e) => toggleContent(note._id, e)}
                        style={{
                          padding: "2px 8px",
                          fontSize: "12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#f5f5f5",
                          cursor: "pointer",
                          color: "#333",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Show Less
                      </button>
                    </>
                  )}
                </p>
                <p>
                  <strong>Created At:</strong> {new Date(note.createdAt).toLocaleString()}
                </p>
              </div>
              <div>
                <p><strong>Court Ref:</strong> {note.courtRef}</p>
                <p>
                  <strong>Updated At:</strong> {new Date(note.updatedAt).toLocaleString()}
                </p>
              </div>
            </div>
            
            <div className="editdel">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setModalTab("Notes");
                  setShowModal(true);
                  onEditNote(note);
                }}
                className="editbtn"
              >
                <BiEdit size={16} />
              </button>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteClick(note._id, note.title);
                }} 
                className="delbtn"
              >
                <BiTrash size={16} />
              </button>
            </div>
          </div>
        ))
      )}

      <DeleteConfirmationModal
        isOpen={deleteModal.isOpen}
        itemType={`this note "${deleteModal.noteTitle}"`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </div>
  );
};